import * as o from "react";
import a from "../lib/IconBase.es.js";
import f from "../defs/ArrowUUpLeft.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: f }));
r.displayName = "ArrowUUpLeftIcon";
const c = r;
export {
  c as ArrowUUpLeft,
  r as ArrowUUpLeftIcon
};
